export const FETCH_COOLDOWN_BY_TASK_REQUEST = 'FETCH_COOLDOWN_BY_TASK_REQUEST';
export const FETCH_COOLDOWN_BY_TASK_SUCCESS = 'FETCH_COOLDOWN_BY_TASK_SUCCESS';
export const FETCH_COOLDOWN_BY_TASK_FAILURE = 'FETCH_COOLDOWN_BY_TASK_FAILURE';
